import { useEffect, useState, type ComponentType } from "react";
import { Skeleton } from "@mui/material";
import { loadLabCard } from "../../utils/federation";
import { CardErrorBoundary } from "./CardErrorBoundary";

const CARD_WIDTH = 204;
const CARD_HEIGHT = 324;

interface CardSlotProps {
  labId: string;
  cardUrl: string;
  cardScope?: string;
}

function CardSlotInner({ labId, cardUrl, cardScope }: CardSlotProps) {
  const [Card, setCard] = useState<ComponentType | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    loadLabCard(labId, cardUrl, cardScope)
      .then((Comp) => {
        if (!cancelled) setCard(() => Comp);
      })
      .catch((err) => {
        console.warn(`Card load failed for "${labId}":`, err);
        if (!cancelled) setFailed(true);
      });
    return () => {
      cancelled = true;
    };
  }, [labId, cardUrl, cardScope]);

  if (failed) return null;

  if (!Card) {
    return (
      <Skeleton
        variant="rounded"
        width={CARD_WIDTH}
        height={CARD_HEIGHT}
        sx={{ borderRadius: 2 }}
      />
    );
  }

  return <Card />;
}

export function CardSlot(props: CardSlotProps) {
  return (
    <CardErrorBoundary>
      <CardSlotInner {...props} />
    </CardErrorBoundary>
  );
}
